module.exports = __webpack_public_path__ + "img/img5.0c4e3a2e.png";